<template>
  <div style='top:0;left:0;width:100%;height:100%;z-index:99;background:#fff;'>
    <!-- <div>登录</div> -->
    <!--头像-->
    <div class="head">
      <div class="img">
        <img src="../../../static/picture/haidilao.png">
      </div>
      <!-- <p>登录模板</p> -->
    </div>
    <!--登陆-->
    <div class="form">
      <div class="item">
        <input type="text" v-model="form.name" name="name" placeholder="请输入您的帐号" autocomplete="off" class="name">
      </div>
      <div class="item">
        <input type="password" v-model="form.password" name="password" placeholder="请输入您的密码" autocomplete="off" class="password">
      </div>
      <div class="submit" @click="submit"><button>登&nbsp;陆</button></div>
    </div>
    <!--第三方登陆-->
    <!--尾部-->
    <div class="footer">
      <p>登录使用就表示同意用户协议<a @click="goxieyi">条款</a>和<a @click="goxieyi">隐私</a>政策</p>
    </div>
   </div>
</template>

<script>
  import GlobalEvent from '@/Event/GlobalEvent.js'
  import {Sticky,Field,CountDown,Toast } from 'vant';
  import {
    doJsonPost,
    doFormPost,
    doJsonGet,
    doFormGet
  } from '@/utils/request';
  export default {
    components:{
        [Sticky .name]:Sticky,
        [Field.name]: Field,
        [CountDown.name]: CountDown,
        [Toast.name]: Toast,
    },
    data() {
      return {
        form:{
          name:'',
          password:'',
        },
      }
      },
    created() {
      // window.open(
      //   "http://epmall.test.36588.com.cn/mobile-api-test/devLoginController/login?account=a0cb47e6fa39dd0876c5c7fd6d57d422&token=C676D5AD113244F9894CAD901193945C"
      //   )
      var account =  localStorage.getItem("account");
      var password =  localStorage.getItem("password");
      if(account&&password){
        this.form.name = account;
        this.form.password  = password
        this.submit();
      }
    GlobalEvent.create('showNavbar').trigger('Navbar',false);
    },
    methods:{
      goxieyi(){
        location.href ="http://www.36588.com.cn/tms/xieyi/sjkyxy.html";
      },
      submit(){
        // that.$router.push({
        //   path: '/category'
        // })
        // return;
        console.info(this.form);
        var that = this;
        // devLoginController/login?account=jn2d@haidilao.com
          // location.href = url;

          // // location.href = url;
          // doJsonGet(url,null, rs => {
          // })
          doFormPost('/userInfo/validVeriCode', {
              account: this.form.name,
              password: this.form.password,
              // login 页面仅海底捞使用，storeCode/shopid 固定为海底捞正式值
              storeCode: 'APP202307000001',
              shopid: 'APP0120230710001'
          }, rs => {
              localStorage.setItem("account", that.form.name);
              localStorage.setItem("password", that.form.password);
              if (rs.result == 'success') {
                // localStorage.setItem("account", that.form.name);
                // localStorage.setItem("password", that.form.password);
                  that.showtips = false;
                  that.$router.push({
                    path: '/category'
                  })
              } else {
                  //Toast(rs.message);
                  localStorage.removeItem(that.key)
                  Toast("您不是指定用户，不能下单");
              }
          });
          // doJsonPost(url,null, rs => {
          // })
      },
      // 更改手机号
      onOKNewPhone() {
        var that = this;
        if(this.isHaidilao){
          if(validateEmail(this.newPhone.account)){
             this.newPhone.valid = true;
             doFormPost('/userInfo/validVeriCode', {
                 account: this.newPhone.account,
                 password: this.newPhone.password
             }, rs => {
                 if (rs.result == 'success') {
                   localStorage.setItem("account", that.newPhone.account);
                    localStorage.setItem("password", that.newPhone.password);
                     that.showtips = false;
                     if(that.$store.state.app.brandConfig.isHaidilao){
                       that. hualaishiUserCheck();
                     }
                 } else {
                     //Toast(rs.message);
                     localStorage.removeItem(that.key)
                     Toast("账号或密码错误");
                 }
             });
          }else{

             this.newPhone.valid = false;
          }
        }else{
          if (isvalidPhone(this.newPhone.phone)) {
              this.newPhone.valid = true;
              doFormPost('/userInfo/validVeriCode', {
                  phone: this.newPhone.phone,
                  veriCode: this.newPhone.veriCode,
                  name: this.newPhone.name
              }, rs => {
                  if (rs.result == 'success') {
                    localStorage.setItem(that.key, true)
                      that.showtips = false;
                  } else {
                      //Toast(rs.message);
                      localStorage.removeItem(that.key)
                      Toast("您不是指定用户，不能下单");
                  }
              });
          } else {
              this.newPhone.valid = false;
          }
        }
      },
    },
  }
</script>

<style scoped="page">
  * {
    margin: 0;
    padding: 0;
    border: 0;
    list-style: none;
    text-decoration: none;
    color: inherit;
    font-weight: normal;
    font-family: "微软雅黑";
    box-sizing: border-box;
    font-style: normal;
  }

  body {
    width: 100%;
    overflow-x: hidden;
    background-size: 100%;
    background:#fff;
  }

  img {
    vertical-align: middle;
    max-width: 100%;
  }

  a:hover,
  a:active,
  a:visited,
  a:link,
  a:focus {
    -webkit-tap-highlight-color: transparent;
    outline: none;
    text-decoration: none;
  }

  /*头像*/
  .head .img {
        width: 100%;
        text-align: center;
  }

  .head img {
    width: 125px;
  }

  .head p {
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
    padding-top: 15px;
  }

  /*登陆表单*/
  .form {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 20px;
  }

  .form .item {
    display: flex;
    align-items: center;
    height: 50px;
    margin-bottom: 35px;
    line-height:50px;
    font-size: 16px;
    color: #333333;
  }

  .form .item input {
    width: 100%;
    height: 100%;
    display: inline-block;
    border: .01rem solid #ebebeb;
    border-radius: .85rem;
    box-shadow: 0px 0px 10px rgba(200, 200, 200, .1);
    padding-left: .8rem;
    outline: none;
  }

  .form .item input.name {
    background: url(../../../static/imgs/user.png) left 15px center no-repeat;
    background-size: 20px 20px;
    padding-left:50px;
  }

  .form .item input.vcode {
    background: url(../../../static/imgs/icon-verify.png) left .3rem center no-repeat;
    background-size: .33rem .33rem;
  }

  .form .item input.password {
    background: url(../../../static/imgs/icon-lock.png) left 15px center no-repeat;
    background-size: 20px 20px;
    padding-left:50px;
  }

  .form .item span {
    flex-shrink: 0;
    display: inline-block;
    width: 1.6rem;
    margin-left: .2rem;
    height: 100%;
    line-height: .85rem;
    border-radius: .85rem;
    background: #1f6ecf;
    font-size: .24rem;
    color: #fff;
    text-align: center;
  }

  .form .item span.disabled {
    background: #808080;
  }

  .form p {
    text-align: center;
    color: #333333;
    font-size: .24rem;
    padding-top: .2rem;
  }

  .form .submit {
    padding: 20px;
  }

  .form .submit button {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    border-radius: .85rem;
    outline: none;
    display: inline-block;
    width: 100%;
    background: #e50112;
  }

  /*第三方登陆*/
  .other-login p {
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.7rem;
    margin: 0 auto;
  }

  .other-login p:after {
    content: "";
    height: .01rem;
    width: 100%;
    background: #808080;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }

  .other-login p span {
    display: inline-block;
    padding: .1rem .3rem;
    background: #FFFFFF;
    color: #808080;
    font-size: .22rem;
    z-index: 2;
  }

  .other-login .third ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .other-login .third ul li img {
    width: .66rem;
    height: .66rem;
    margin: 0 .25rem;
  }

  /*尾部*/
  .footer {
    text-align: center;
    padding-top: .3rem;
  }

  .footer img {
    display: inline-block;
    width: 300px;
    margin-top:50px;
  }

  .footer p {
    font-size: .20rem;
    color: #666666;
    text-align: center;
    padding: .1rem 0 .4rem 0;
    letter-spacing: .01rem;
  }

  .footer p a {
    color: #078dda;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue